module.exports = __webpack_public_path__ + "img/campaignpilot-templates-img-lr.5101980d.jpg";